import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function FinalCTA() {
  return <section className="bg-navy px-3 py-5 text-center sm:px-6" data-id="element-50" data-mp="3uei1xeuj5o1t">
      <div className="mx-auto max-w-2xl" data-id="element-51" data-mp="c7tzjwqv7ezu">
        <h2 className="font-heading text-[1.05rem] font-bold uppercase text-gold sm:text-[1.6rem]" data-id="element-52" data-mp="c4fuggqtgrop">
          One last question
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-53" data-mp="m46nsf3n50n7">
          How many times have you reviewed a laboratory result knowing what you
          were looking for... but still had to search scattered references and
          compare disconnected values again? You can keep moving between
          textbooks, values, images and separate resources. Or you can open one
          organized professional system.
        </p>
        <p className="mt-1 font-body text-[0.72rem] font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-54" data-mp="zwd1zvn8gxk0">
          Observe. Compare. Connect. Recognize.
        </p>

        <a href={PURCHASE_ANCHOR} className="mt-1.5 block" data-id="element-55" data-mp="2c6hkmjpbu5hw">
          <img src={BOX_IMAGE} alt="CLINICAL LAB VISUAL ATLAS™ complete system" className="mx-auto w-full max-w-[190px] drop-shadow-2xl" data-id="element-56" data-mp="2h4srclkbrzvw" />
        </a>

        <p className="mt-1 font-heading text-[1.15rem] font-bold uppercase leading-tight text-white sm:text-[1.6rem]" data-id="element-57" data-mp="2r275geis0cl1">
          🧪 Clinical Lab Visual Atlas™
        </p>
        <p className="font-body text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-58" data-mp="302c4a09wm2nl">
          The Complete Visual Reference System for Clinical Lab Science
        </p>
        <p className="mt-0.5 text-[0.66rem] text-white/70 sm:text-[0.8rem]" data-id="element-59" data-mp="39sf52mn9okwh">
          Hematology • Clinical Chemistry • Microbiology • Immunology •
          Urinalysis • Blood Bank
        </p>

        <p className="mt-2 font-body text-[0.86rem] font-extrabold uppercase text-gold sm:text-base" data-id="element-60" data-mp="3it38knf1b2v4">
          🔥 Get the complete system today
        </p>
        <div className="mx-auto mt-1 max-w-md" data-id="element-61" data-mp="1jp4s1kbqipkp">
          <CTAButton label="🧪 Get Clinical Lab Visual Atlas™" sub="Immediate Access • Digital Delivery" data-id="element-62" data-mp="1ep8n9iv7qu43" />
          <TrustLine className="mt-1.5 !text-white/75" data-id="element-63" data-mp="1shgkfbqesn3b" />
        </div>
      </div>
    </section>;
}